<template>
  <div class="row">
    <div class="col-12">
      <card>
        <div class="row">
          <div class="col-12 col-sm-5 col-md-6">
            <label for="">{{ $t('common_words.farm') }}: </label>
            <br />
            <el-select
              clearable
              filterable
              style="width: 100%"
              class="select-primary mb-3 shadow-sm required-farm"
              v-model="confirmationReportForm.farm_id"
              :placeholder="`${$t('common_words.select2')}...`"
              @input="change"
            >
              <el-option
                class="select-primary"
                v-for="item in farms"
                :key="item.id + item.name"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-5 col-md-6">
            <label for="">{{ $t('diseases.plague_or_disease') }}: </label>
            <br />
            <el-select
              @change="
                selectAllFromSelect(
                  'confirmationReportForm.diseases_id',
                  diseases
                )
              "
              clearable
              filterable
              collapse-tags
              multiple
              style="width: 100%"
              class="select-primary mb-3 shadow-sm required-diseases"
              v-model="confirmationReportForm.diseases_id"
              :placeholder="`${$t('common_words.select2')}...`"
              @input="change"
            >
              <el-option
                class="select-primary selected-all"
                v-for="disease in diseases"
                :key="disease.id + disease.name"
                :label="disease.name"
                :value="disease.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-5 col-md-6">
            <label for="">{{ $t('common_words.status') }}: </label>
            <br />
            <el-select
              clearable
              filterable
              style="width: 100%"
              class="select-primary mb-3 shadow-sm required-state"
              v-model="confirmationReportForm.status_id"
              :placeholder="`${$t('common_words.select2')}...`"
              @input="change"
            >
              <el-option
                class="select-primary"
                v-for="item in [
                  { id: 0, value: $t('common_words.confirm_waiting') },
                  { id: 1, value: $t('common_words.confirmed') },
                ]"
                :key="item.id + item.value"
                :label="item.value"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.date') }} *</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              class="shadow-sm required-date"
              v-model="rangeDate"
              type="daterange"
              :picker-options="pickerOptions"
              :placeholder="`${$t('common_words.select2')}...`"
              @input="change"
            >
            </el-date-picker>
          </div>

          <div class="col-12 col-md-4 col-xl-2">
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.filter')
            }}</label
            ><br />
            <l-button wide type="info" class="btn-filter" @click="validate">
              {{ $t('common_words.filter') }}
            </l-button>
          </div>
        </div>
      </card>
      <card v-if="confirmationReporting">
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              filterable
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="row">
            <div class="col-sm-12">
              <el-table
                stripe
                :default-sort="{ prop: 'name', order: 'descending' }"
                :data="queriedData"
                height="500"
                style="width: 100%"
                :border="true"
              >
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                  :fixed="column.fixed"
                ></el-table-column>

                <el-table-column
                  width="150px"
                  prop="disease_name"
                  :label="$t('diseases.suspicions')"
                >
                </el-table-column>

                <el-table-column width="150px" :label="$t('diseases.symptoms')">
                  <template slot-scope="scope">
                    <ul>
                      <li
                        v-for="(symptom, index) in scope.row.symptoms"
                        :key="'reportConfirmation' + index"
                      >
                        {{ symptom.disease_symptom }}
                      </li>
                    </ul>
                  </template>
                </el-table-column>

                <el-table-column
                  width="150px"
                  :label="$t('diseases.diagnosis')"
                >
                  <template slot-scope="scope">
                    <ul>
                      <li
                        v-for="(disease, index) in scope.row.confirmed_diseases"
                        :key="'confirmed' + index"
                      >
                        {{ disease.name }}
                      </li>
                    </ul>
                  </template>
                </el-table-column>

                <el-table-column
                  min-width="150px"
                  prop="confirmation_date"
                  :label="$t('diseases.results_deadlines')"
                >
                  <template slot-scope="scope">
                    {{ formatConfirmationDate(scope.row.confirmation_date) }}
                  </template>
                </el-table-column>

                <el-table-column
                  min-width="150px"
                  :label="$t('diseases.results_lab')"
                >
                  <template slot-scope="props">
                    <div
                      v-if="
                        props.row.confirmation_pdf != null &&
                        props.row.confirmation_pdf != ''
                      "
                    >
                      <a
                        :href="props.row.confirmation_pdf"
                        target="_blank"
                        v-tooltip.top-center="$t('diseases.results_lab_see')"
                        class="btn-info btn-simple btn-link custom-margin-actions"
                      >
                        <em class="fa fa-solid fa-download"></em>
                      </a>
                    </div>
                    <div
                      v-if="
                        props.row.confirmation_pdf == null &&
                        props.row.confirmation_pdf == ''
                      "
                    >
                      -
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
        <br />
        <div class="row" style="padding-right: 13px; padding-left: 13px">
          <div class="col-6" v-if="isPDF()">
            <div class="text-right">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="exportToPDF"
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
          </div>
          <div class="col-6" v-if="isExcel()">
            <div class="text-left">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="exportToExcel"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { mapActions } from 'vuex';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import MixinDatePicker from 'src/util/mixinDatePicker';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import configTable from './confirmationReportTable.js';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
  },

  computed: {
    ...configTable().Search,
  },

  data() {
    return {
      confirmationReportForm: {
        farm_id: [],
        diseases_id: [],
      },
      rangeDate: [],
      tableData: [],
      diseases: [],
      pagination: {},
      tableColumns: [],
      farms: [],
      confirmationReporting: false,
    };
  },

  watch: {
    '$i18n.locale': ['getSelectAll', 'setupTable', 'forceRerender'],
  },

  mixins: [
    MixinDatePicker,
    mixinMasters,
    MixinPermissions,
    MixinExport,
    MixinMenu,
  ],

  methods: {
    getSelectAll() {
      this.diseases = this.concatAll(this.diseases.splice(1));
    },
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    formatConfirmationDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },

    validate() {
      this.tableData = [];
      this.confirmationReporting = false;
      if (!this.confirmationReportForm.farm_id) {
        return this.validationInputsRequired('farm')
          .then((response) => {})
          .catch((error) => {});
      } else if (![0, 1].includes(this.confirmationReportForm.status_id)) {
        return this.validationInputsRequired('state')
          .then((response) => {})
          .catch((error) => {});
      } else if (this.confirmationReportForm.diseases_id.length === 0) {
        return this.validationInputsRequired('diseases')
          .then((response) => {})
          .catch((error) => {});
      } else {
        this.loadData();
      }
    },

    change() {
      this.confirmationReporting = false;
    },

    loadData() {
      console.log(this.confirmationReportForm);
      this.pagination.currentPage = 1;
      let data = {
        farm_id: this.confirmationReportForm.farm_id,
        status: this.confirmationReportForm.status_id,
        diseases_id: this.confirmationReportForm.diseases_id,
        route: 'diseases/casesconfirmationreport',
        init: moment(this.rangeDate[0]).format('YYYY-MM-DD'),
        end: moment(this.rangeDate[1]).format('YYYY-MM-DD'),
      };
      this.showHideLoading(true);
      Axios.postMasters(data)
        .then((response) => {
          this.showHideLoading();
          if (response.data.length > 0) {
            response.data.forEach((element) => {
              element.confirmation_date = moment(
                element.confirmation_date,
                'YYYY-MM-DD'
              );
            });
            this.tableData = response.data;
            this.confirmationReporting = true;
          } else {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          }
        })
        .catch((error) => {
          this.showHideLoading();
          console.log(error);
          SweetAlert.warning(i18n.t('common_words.unavailable_data'));
        });
    },

    exportToPDF() {
      let data = {
        farm_id: this.confirmationReportForm.farm_id,
        status: this.confirmationReportForm.status_id,
        diseases_id: this.confirmationReportForm.diseases_id,
        init: moment(this.rangeDate[0]).format('YYYY-MM-DD'),
        end: moment(this.rangeDate[1]).format('YYYY-MM-DD'),
      };
      data.route = 'diseases/casesconfirmationreport/pdf';
      data.name_file = `${i18n.t('diseases.confirmation_report')}.pdf`;
      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToExcel() {
      let data = {
        farm_id: this.confirmationReportForm.farm_id,
        status: this.confirmationReportForm.status_id,
        diseases_id: this.confirmationReportForm.diseases_id,
        init: moment(this.rangeDate[0]).format('YYYY-MM-DD'),
        end: moment(this.rangeDate[1]).format('YYYY-MM-DD'),
      };
      data.route = 'diseases/casesconfirmationreport/excel';
      data.name_file = `${i18n.t('diseases.confirmation_report')}.xlsx`;
      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('farms/farms/onlyfruit'),
        Axios.getMasters('diseases/diseasesonly'),
      ])
        .then((response) => {
          this.farms = response[0].data.data;
          this.diseases = this.concatAll(response[1].data);
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }

    let current = new Date();
    this.rangeDate = [
      new Date(current.setDate(current.getDate() - current.getDay())),
      new Date(current.setDate(current.getDate() - current.getDay() + 6)),
    ];
  },

  mounted() {
    this.selectedItemOnMenu('diseases');
  },

  destroyed() {
    this.deselectedItemOnMenu('diseases');
  },
};
</script>

<style scoped></style>
